module.exports = {
      id: "twitter-icon-usage",
      viewBox: "0 0 135.08 135.08",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#twitter-icon",
      toString: function () {
        return this.url;
      }
    }